module.exports = __webpack_public_path__ + "img/95b1175.png";